{
  "add-a-stream": {
    "button": "Add a stream"
  },
  "add-new-page": {
    "audio-dedications": "Audio Shout-out",
    "dedications": "Dedication",
    "html": "HTML",
    "livefeed": "LiveFeed",
    "podcast": "Podcast",
    "reveil": "Alarm Clock",
    "rss": "RSS",
    "rss-news": "News",
    "rss-podcasts": "Podcast",
    "rss-video": "Video",
    "site": "Website",
    "song-history": "Song History",
    "title": "Add a page"
  },
  "android-screenshot": {
    "desc": "<p class='mb-[10px]'>The displayed visual corresponds to the preview generated during publication. This status indicates that your app was published for the first time.</p><p>It is not automatically updated: updates, verifications or alerts must be followed from your Google developer account.</p>",
    "title": "Your application is available on the Google Play Store."
  },
  "app-update-available": {
    "cta": "Update",
    "description": "Enjoy the latest app features",
    "title": "Update available"
  },
  "app-update-modal": {
    "desc": "To update your application, you will need to generate the new version and follow the update tutorial.",
    "title": "Updating your application"
  },
  "assets": {
    "app-logo": "App logo",
    "app-logo-explained": "This image corresponds to your application's logo.",
    "app-logo-size": "Recommended size : 2500px x 2500px",
    "app-name": "Your radio app name",
    "apple-only": "Only on Apple",
    "change-image": "Replace image",
    "constraints-icon-smartphone": "Recommended size: 1024 x 1024px",
    "constraints-icon-tv": "Recommended size: 1280 x 768px",
    "constraints-smartphone": "Recommended size: 1242 x 2208px",
    "constraints-smartphone-long": "Recommended size: 1242 x 2688px",
    "constraints-topshelf-tv": "Recommended size: 4640 x 1440px",
    "constraints-tv": "Recommended size: 3840 x 2160px",
    "crop-image": "Recrop image",
    "icon-tv": "Icon for TV app",
    "icon-tv-description": "This icon is displayed on the TV applications' homepage.",
    "images-title": "Screens and logos",
    "large-screen": "Large screen",
    "logo": "App icon",
    "logo-description": "This image represents the icon that the user clicks to launch the application.",
    "next-step": "Next step",
    "restrictions": "Technical restrictions",
    "restrictions-icon-tv": "Must include the full name of the application, with no cut text or mention of FM frequency, unless present in the name.",
    "restrictions-splashscreen-tv": "Neither the image nor the text must be cut.",
    "smartphone": "Smartphone",
    "smartphone-description": "This image corresponds to the display at the launch of the app.",
    "smartphone-long-description": "This image corresponds to the display at the launch of the app on phones with a larger screen.",
    "splashscreens": "Splash screens",
    "splashscreens-explained": "This image corresponds to the display at the launch of the application on different devices (phone, television)",
    "splashscreens-size": "Recommended size: 2500px x 2500px",
    "topshelf-tv-description": "Image displayed as a preview of the application in the Apple TV interface",
    "topshelf-tv-short": "TV Banner",
    "tv": "TV Screen",
    "tv-description": "This image is displayed at the launch of the app on television.",
    "update-image-title": "Screens and logos"
  },
  "audio-dedications": {
    "choose-radio": "Choose a radio",
    "end": "End",
    "end-placeholder": "Thank you for your dedication!",
    "need-a-rk-radio": "This page requires a RadioKing stream to work.",
    "radio": "Radio",
    "rk-create-radio-cta": "Create my radio",
    "rk-radio-create-link": "/create-radio",
    "text": "Text",
    "welcome": "Welcome",
    "welcome-placeholder": "Send your dedication on air!"
  },
  "changelog": {
    "fixes": "Fixes",
    "improvement": "Improvements",
    "new": "New",
    "read-more": "Read more",
    "title": "Changelog"
  },
  "color-selector": {
    "hex-error": "The color code is not correct.",
    "opacity": "Opacity",
    "opacity-error": "Opacity must be between 0 and 100"
  },
  "config-submenu": {
    "content": "Content",
    "design": "Design"
  },
  "create-app-form": {
    "change-image": "Change image",
    "choose-name": "Choose the app name",
    "choose-name-explained": "Choose a unique name for your mobile application. You can always change it later if necessary.",
    "max-length": "Maximum length is 30 characters.",
    "min-length": "Minimum length is 2 characters.",
    "missing-name": "Name is required.",
    "name-placeholder": "Your app's name",
    "no-emojis": "Emojis are not allowed.",
    "no-spaces-only": "Name cannot be only spaces.",
    "start": "Start",
    "unavailable-name": "This app name is already taken"
  },
  "dashboard": {
    "consumption": "Notification Consumption",
    "hello": "Hello",
    "new-subscribers": "New Subscribers in the last 7 days",
    "new-subscribers-unit": "{count, plural, =1 {New Subscriber} other {New Subscribers}}",
    "notifications-sent": "Notifications Sent",
    "notifications-sent-unit": "{count, plural, =1 {Notification} other {Notifications}}",
    "subscriber-detail": "User Distribution",
    "subscribers-total": "Notification Subscribers",
    "title": "Notification Statistics",
    "welcome": "Welcome to your dashboard."
  },
  "general-configuration": {
    "app-langugage": "App language",
    "background-color": "Color 1",
    "background-color-2": "Color 2",
    "background-color-style": "Style",
    "background-gradient-direction": "Direction",
    "bicolor-color-tooltip": "Bicolor",
    "blur": "Blur",
    "blur-details": "The background blur allows you to add a visual effect to your image to highlight the main content.",
    "body-size": "Body size",
    "button-color": "Button color",
    "button-label": "Button",
    "button-type": "Button type",
    "color": "Color",
    "cover": "Cover",
    "cover-background-details": "The cover of the current track will be displayed as a background image.",
    "default-background-image": "Default image",
    "font-size": "Text size",
    "gradient-color-tooltip": "Gradient",
    "header": "Header",
    "header-text-color": "Text color",
    "icons": "Icons",
    "image": "Image",
    "invert-colors": "Invert colors",
    "long-background-image": "Long image",
    "rounded-borders": "Rounded borders",
    "shodow-box": "Shadows",
    "show-logo": "Show logo",
    "solid-color-tooltip": "Solid",
    "styles": "Styles",
    "styles-background": "Background",
    "text-align": "Text alignment",
    "typography": "Typography"
  },
  "global": {
    "cancel": "Cancel",
    "share": "Share",
    "url-copied": "The URL has been successfully copied to the clipboard.",
    "url-copy-failed": "Unable to copy the URL to the clipboard. Please try again.",
    "url-invalid": "The URL is incorrect",
    "validate": "Validate"
  },
  "header": {
    "help-link": "https://help.radioking.com/hc/en-us/categories/4408651163665-Mobile-application"
  },
  "html-config": {
    "background": "HTML block background",
    "code-placeholder": "Enter your HTML code here",
    "content": "Page contents"
  },
  "icon-search": {
    "icon-name": "Icon name"
  },
  "icon-type-selector": {
    "regular": "Outlined",
    "solid": "Filled"
  },
  "image-cropper": {
    "cancel": "Cancel",
    "iconTv": "Change the TV app icon",
    "logo": "Change the app logo image",
    "recommended": "Recommended size",
    "replace": "Replace the image",
    "restrictions": "Technical restrictions",
    "rotation": "Rotation",
    "save": "Save",
    "splashscreen": "Change the splash screen image",
    "splashscreenLarge": "Change the large splash screen image",
    "splashscreenTv": "Change the TV screen image",
    "topShelfTv": "Change the TV banner image",
    "zoom": "Zoom"
  },
  "image-input": {
    "cancel": "Cancel",
    "dragging-over-text": "Drop your image to load it",
    "load": "load",
    "main-text": "Drag and drop \nor"
  },
  "image-size-guide": {
    "size": "Recommended size: \n{width} x {height}px\nMax size: 10Mo"
  },
  "image-upload": {
    "alt": "Uploaded image",
    "change-image": "Change image",
    "constraints-title": "Technical specifications",
    "delete": "Delete",
    "file-size-error": "Max file size is 10Mo",
    "file-type-error": "Accepted formats: .jpg, .jpeg, .png,"
  },
  "ios-publishing-empty-state": {
    "cta": "Upgrade to premium",
    "desc": "Your listeners are also on iPhone. Add the iOS option and offer them a complete experience, directly from the App Store.",
    "title": "Your application on iOS"
  },
  "ios-screenshot": {
    "desc": "<p class='mb-[10px]'>The displayed visual corresponds to the preview generated during publication. This status indicates that your app was published for the first time.</p><p>It is not automatically updated: updates, verifications or alerts must be followed from your Apple developer account.</p>",
    "title": "Your application is now available on the Apple Store."
  },
  "login": {
    "login-button": "Login"
  },
  "margin-settings": {
    "no-margin": "No margin",
    "with-margin": "With margin"
  },
  "menu-content": {
    "title-error": "The page name must contain at least two characters"
  },
  "menu-design": {
    "background": "Background",
    "show-logo": "Show logo",
    "styles": "Styles",
    "text-color": "Text color"
  },
  "menu": {
    "configuration": "Configuration",
    "content": "Design and content",
    "dashboard": "Dashboard",
    "notifications": "Notifications",
    "pages": "Pages",
    "publication": "Publishing",
    "publishing": "Publishing",
    "settings": "Settings"
  },
  "mobile-access-warning": {
    "cta": "Access the desktop version",
    "description": "Your app simulator is not yet available on mobile. In the meantime, you can enjoy all its features on your computer.",
    "description-app-manager": "Your application manager is not yet available on mobile. In the meantime, you can enjoy all its features on your computer.",
    "title": "Available soon"
  },
  "mock-tabs": {
    "alarm": "Alarm",
    "dedications": "Dedications",
    "podcast": "Podcast",
    "podcast-link": "https://feed.ausha.co/o9W6DIj52NE0",
    "rss": "RSS feed",
    "rss-link": "https://www.radioking.com/blog/feed",
    "rss-news": "News",
    "rss-podcasts": "Podcast",
    "rss-video": "Video",
    "shout-outs": "Shout outs",
    "song-history": "Song History",
    "video-link": "https://www.youtube.com/feeds/videos.xml?channel_id=UCuA6ECflXH9hpx5iDBa79uw",
    "website": "Website"
  },
  "monetization": {
    "ad-unit-id": "Ad Unit ID",
    "admob-configuration-tutorial": "How to configure AdMob?",
    "admob-configuration-tutorial-url": "https://help.radioking.com/hc/en-us/articles/4410223563025",
    "admob-get-id-tutorial": "How to get your AdMob IDs?",
    "admob-get-id-tutorial-url": "https://help.radioking.com/hc/en-us/articles/4410238783377",
    "and": "and",
    "android-app-id": "Android App ID",
    "banner": "Banner",
    "banner-description": "Advertising displayed on the application's Player page.",
    "change-offer-text": "Upgrade to monetization. An easy way to start generating revenue with your app.",
    "configure-later": "You can set up monetization now or activate it later.",
    "description-1": "Google AdMob lets you monetize your application by displaying advertising.",
    "description-2": "To configure Admob, go to the AdMob website",
    "interstitial": "Interstitial",
    "interstitial-description": "Advertising displayed when the application is opened.",
    "ios-app-id": "iOS App ID",
    "next-step": "Next step",
    "option-toggle": "Activate ads",
    "our-tutorials": "on our tutorials",
    "title": "Monetization"
  },
  "new-stream": {
    "name": "My Radio"
  },
  "notification-congrats-dialog": {
    "button": "Start",
    "desc": "Take full control of your mobile app with ease! Customize it, send notifications, and track your performance directly from your dashboard.",
    "title": "Congratulations on setting up your application!"
  },
  "notification-dashboard": {
    "empty-state": {
      "desc": "Your application has just been published. Your first results will appear on this dashboard shortly.",
      "title": "You don't have any statistics yet",
      "tutorial": {
        "card1": {
          "desc": "Learn how to send, target and analyze your push notifications to engage your audience effectively.",
          "title": "Everything You Need To Know About Push Notifications",
          "url": "https://help.radioking.com/hc/en-us/articles/4410238827409"
        },
        "card2": {
          "desc": "Discover how easy it is to configure, update and publish your mobile application.",
          "title": "All about the Mobile Application",
          "url": "https://help.radioking.com/hc/en-us/categories/4408651163665"
        },
        "learn-more": "Learn more",
        "title": "Let us guide you"
      }
    },
    "send": "Send a notification",
    "title": "Notifications",
    "total": "{count, plural, =0 {Send your first notification} =1 {You have sent one notification} other {You have sent # notifications}}"
  },
  "notification-form": {
    "cancel": "Cancel",
    "close-confirmation-button": "Yes, leave.",
    "close-confirmation-message": "Are you sure you want to leave the creation of your notification?",
    "close-confirmation-message-details": "Closing the current window will result in the loss of ongoing changes. Are you sure you want to exit without saving?",
    "close-confirmation-tooltip": "An error has occurred in the wording of your notification. To save it, please check the form.",
    "date-placeholder": "Choose a date",
    "deeplink": "Deep Link",
    "deeplink-desc": "When the notification is clicked, the listener will be redirected to the selected page.",
    "deeplink-placeholder": "Select a page",
    "draft": "Save as draft",
    "episode-placeholder": "Select an episode",
    "episode-selection": "Episode (optional)",
    "language": "Language",
    "language-placeholder": "Choose your language(s)",
    "location": "Location",
    "location-placeholder": "Country, city, region, ...",
    "location-search": "Send a geolocated notification",
    "message": "Message",
    "message-error": "The message must contain between 3 and 140 characters.",
    "message-placeholder": "Write your message",
    "new": "New notification",
    "os": "Operational system",
    "platform-error": "Choose at least one operating system",
    "podcast-placeholder": "Select a podcast",
    "podcast-selection": "Podcast title (optional)",
    "radio-placeholder": "Select a radio",
    "radio-selection": "Radio",
    "schedule": "Schedule",
    "send": "Send",
    "time-placeholder": "Time",
    "title": "Title",
    "title-error": "The title (optional) must contain between 3 and 50 characters.",
    "title-placeholder": "Title of your notification",
    "tooltip-support-ios": "To send your notifications on iOS, upgrade to the higher subscription.",
    "tooltip-unavailable-android": "Notifications are not yet available for your Android application.",
    "tooltip-unavailable-ios": "Notifications are not yet available for your iOS application."
  },
  "notification-sidebar": {
    "empty-state": {
      "desc": "After the first send, your notification history will be available.",
      "title": "Send your first notification"
    },
    "scheduled": "Scheduled"
  },
  "notification-table": {
    "android": "Sent on Android",
    "date": "Send date",
    "draft": "Draft",
    "empty-state-desc": "Let your listeners know what's new on your radio, what's going on, and much more.",
    "ios": "Sent on iOS",
    "message": "Message",
    "not-sent-android": "This notification has not been sent on Android",
    "not-sent-ios": "This notification has not been sent on iOS",
    "reach": "Subscribers reached"
  },
  "notification-targeted-subscribers": {
    "android": "on Android",
    "ios": "on iOS",
    "total": "Estimated sends"
  },
  "onboarding-modal": {
    "content-design": {
      "button": "Continue editing",
      "desc": "Use the tabs to toggle between editing content and customizing the design of the selected page.",
      "title": "Content and design"
    },
    "general-configuration": {
      "desc": "Customize the theme of your mobile application to suit your specific needs.",
      "title": "Theme configuration"
    },
    "interface": {
      "button": "Finish",
      "desc": "Customize the visual elements of your application. Adjust language, colors, typography and icons to create a unique user experience.",
      "title": "Interface customization"
    },
    "menu": {
      "desc": "Organize and customize your mobile application's menu for optimal listener navigation.",
      "title": "Menu management"
    },
    "next": "Next",
    "pages": {
      "desc": "Create, modify and organize the pages of your mobile application.",
      "title": "Page management"
    },
    "previous": "Previous",
    "stepper": {
      "button": "Taking the next step",
      "desc": "View your progress at each stage of project creation. Click on “Next step” to continue.",
      "title": "Track your progress"
    }
  },
  "other-config": {
    "need-a-rk-website": "⚠️ This page requires a RadioKing website to work.",
    "rk-website-create-link": "/create-radio-cms-website",
    "rk-website-cta": "Create my Radio Website",
    "rk-website-link": "Link to your radio website",
    "rss-link": "RSS feed link",
    "website-link": "Website link",
    "what-is-rss": "An <strong>RSS feed</strong> is a web link that automatically updates with your latest content.<br/>If you're unsure where to find your RSS feed, check your content platform or hosting service—it's usually labeled as 'RSS Feed' or 'Feed URL'."
  },
  "page-config": {
    "background-color": "Background color",
    "header-text-color": "Header text color",
    "icon-and-name": "Icon and page name"
  },
  "paid-publication-modal": {
    "buy": "Add to cart",
    "buy-android": "Publish on Android",
    "buy-ios": "Publish on iOS",
    "cancel": "Cancel",
    "message": "For { price } per platform, RadioKing takes care of publishing your application on your Apple or Google developer accounts, in compliance with store requirements. <a target='_blank' href='https://www.radioking.com/app-publishing' class='underline text-brand'>Discover the steps that will be carried out in detail.</a>",
    "title": "Publication by RadioKing"
  },
  "plan": {
    "all-basic": "All Basic offer features",
    "all-smart": "All Smart offer features",
    "android": "Native app for <b>Android</b>",
    "android-and-ios": " Native app for <b>Android & iPhone</b>",
    "android-tablet": "Compatible with <b>Android tablet</b>",
    "annual": "Annual",
    "apple-watch": "<b>Apple Watch</b>",
    "auto": "<b>Android Auto & Apple CarPlay</b>",
    "carplay-tooltip": "Subject to acceptance by Apple (1-3 weeks) for Carplay",
    "choose": "Choose this offer",
    "customizable": "100% customizable design",
    "monetization": "Monetization",
    "monetization-tooltip": "Advertising manager: AdMob",
    "monthly": "Monthly",
    "multi-language": "Multilingual",
    "multi-language-tooltip": "Choose between 6 different languages when creating the App: FR, EN, ES, DE, IT, PT",
    "multi-stream": "Add multiple radio streams",
    "multi-stream-tooltip": "Compatible with Shoutcast, Icecast & other providers",
    "per-month": "/month",
    "per-year": "/year",
    "pick-title": "Choose my offer",
    "plus": "plus",
    "publication-tooltip": "Valid for 1 publication only",
    "push": "<b>{number}</b> push notifications",
    "push-tooltip": "<b>Additional notifications:</b></br>100,000: +{currency}5/month</br>300,000: +{currency}15/month</br>500,000: +{currency}25/month</br>750,000: +{currency}35/month",
    "recommended": "Recommended for you",
    "rk-published": "App published by RadioKing <b>INCLUDED</b>",
    "subtitle": "Choose the offer you and your team need.",
    "tablet": "Compatible with <b>iPad & Android tablet</b>",
    "tv": "<b>Android TV & Apple TV</b>",
    "two-months-free": "2 months free",
    "unlimited-downloads": "<b>UNLIMITED</b> app downloads",
    "unlimited-tabs": "<b>UNLIMITED</b> tabs",
    "user-published": "App published by RadioKing (optional)",
    "user-published-tooltip": "{currency}50 per App publication",
    "white-label": "White label",
    "white-label-tooltip": "White Label allows you to remove any 'RadioKing' branding from your application."
  },
  "player-buttons": {
    "apple": "Buy via Apple Music",
    "apple-afiliate-help-link": "https://help.radioking.com/hc/en-us/articles/4409541483665-External-APIs-How-to-Get-Your-Apple-Partner-formerly-iTunes-Affiliate-Code",
    "apple-music-placeholder": "Your Apple Music Affiliate ID",
    "auto-play": "Auto play",
    "email": "Email",
    "email-error": "The email address is not correct",
    "infobox-itunes": "💡 The 'Buy via Apple Music' button allows your listeners to purchase the current track. It's a great way for you to monetize your app.<br/><br/>To take advantage of this, you need to sign up for the Apple Affiliate Program.",
    "infobox-itunes-cta": "Learn more",
    "mail-placeholder": "contact@my-radio.com",
    "other-actions": "Other actions",
    "phone": "Call",
    "phone-error": "The phone number is not correct",
    "phone-placeholder": "+44 72 90 78 65",
    "share": "Share",
    "sleep-timer": "Sleep timer",
    "sms": "SMS",
    "sms-placeholder": "+44 79 60 22 96",
    "title": "Buttons",
    "vote": "Vote",
    "vote-explained": "Votes allow your listeners to tell you when they like your music. This feature is only available for radios hosted by RadioKing."
  },
  "player-content": {
    "icon-and-name": "Icon and page name",
    "stream": "Radio stream"
  },
  "player-design": {
    "always-show-default-cover": "Always display the default cover",
    "artist-color": "Artist color",
    "constraints-body": "Recommended size: 440 x 440px\nMaximum weight: 10MB\nAccepted formats: .jpg, .jpeg, .png",
    "cover": "Default cover",
    "cover-border-color": "Cover border color",
    "cover-explained": "The default cover is the image that replaces the current track's photo if it does not have one.",
    "cover-shape": "Cover shape",
    "cover-type": "Cover style",
    "show-cover-border": "Show cover border",
    "title-and-artist": "Title and artist",
    "title-color": "Title color",
    "titling-background": "Background"
  },
  "privacy": {
    "description": "Configure your consent management platform (CMP) settings for GDPR compliance.",
    "didomi-api-key": "Didomi API Key",
    "didomi-api-key-placeholder": "Enter your Didomi API Key",
    "didomi-notice-id": "Didomi Notice ID",
    "didomi-notice-id-placeholder": "Enter your Didomi Notice ID",
    "option-toggle": "Enable Didomi CMP",
    "privacy-policy-url": "Privacy policy URL",
    "privacy-policy-url-placeholder": "https://example.com/privacy",
    "terms-of-service-url": "Terms of service URL",
    "terms-of-service-url-placeholder": "https://example.com/terms",
    "title": "Privacy"
  },
  "podcast-config": {
    "add": "Add a podcast",
    "duplicate": "This podcast URL is already added",
    "episodes": "episodes",
    "feed-link": "Podcast feed link",
    "invalid": "The entered URL is not a podcast RSS feed"
  },
  "publication-addon-dialog": {
    "accept": "Radioking publishes for me",
    "message": "We take care of the entire publication of your application on your Apple and Google developer accounts. Entrust us with this task, and ensure that your app is online quickly, in accordance with platform requirements.<br/><br/>This option costs only { price } once.<br/><br/>If you wish to publish it yourself, our tutorials will guide you step-by-step.",
    "refuse": "I publish myself",
    "title": "Do you want RadioKing to publish the application for you?"
  },
  "publishing-banner": {
    "cta": "Publish",
    "description": "For €50 per platform, RadioKing takes care of publishing your application on your Apple or Google developer accounts, in compliance with store requirements. ",
    "link": "https://www.radioking.com/app-publishing",
    "link-description": "Learn more about publication by RadioKing.",
    "title": "RadioKing publishes for me"
  },
  "publishing-step": {
    "android-dev-account-cta": "Create my account",
    "android-dev-account-description": "Creating and validating your Google Developer Account is necessary to publish your application. To learn more, check out our tutorial.",
    "android-dev-account-label": "Create my Play Store account",
    "android-tutorial-description": "Follow the tutorial to submit your application to Google and publish it on the Play Store.",
    "android-tutorial-label": "Upload the application to Play Store",
    "download-cta": "Download my application",
    "download-description": "Download your application archive. This archive is necessary for publishing on the stores.",
    "download-label": "Download the application",
    "existing-dev-account": "I already have an account",
    "generation-cta": "Start generation",
    "generation-description": "This step starts the automatic process of creating your application from the elements you have provided (name, icon, content, etc.). Once generation is complete, you can download the files required for publication.",
    "generation-label": "Generate the application",
    "in-progress": "In progress",
    "ios-carplay-cta": "Request CarPlay authorization",
    "ios-carplay-description": "Request authorization from Apple to make your application compatible with CarPlay. This may take several weeks.",
    "ios-carplay-label": "Request CarPlay authorization",
    "ios-dev-account-cta": "Create my account",
    "ios-dev-account-description": "Creating and validating your Apple Developer Account is necessary to publish your application. To learn more, check out our tutorial.",
    "ios-dev-account-label": "Create my App Store account",
    "ios-tutorial-description": "Follow the tutorial to submit your application to Apple and publish it on the App Store.",
    "ios-tutorial-label": "Upload your application to App Store",
    "published-label": "Congratulations, your application is online!",
    "tutorial-cta": "Start publishing"
  },
  "publishing": {
    "app-swap": "Switch application",
    "subtitle": "Publish your application step by step and monitor its publication status",
    "title": "Publishing status"
  },
  "setting-confirmation-modal": {
    "cancel": "Cancel",
    "description": "To make your setting changes visible to users, your application will need to be republished.",
    "documentation": "documentation",
    "link": "https://help.radioking.com/hc/en-us/articles/26106170721041",
    "link-description": "You will find more information in our ",
    "save": "Save without publishing",
    "save-redirect": "Save and publish",
    "title": "Publish changes"
  },
  "settings-list": {
    "general-configuration": "Theme settings",
    "menu": "Menu",
    "pages": "Pages"
  },
  "simulator-preview": {
    "add-image-text": "Upload an image to see the preview",
    "add-image-title": "Add your Image"
  },
  "song-history-config": {
    "api-url": "API URL",
    "api-url-description": "API providing the history of recently played tracks.",
    "search-api-url": "Search API URL",
    "search-api-url-description": "API allowing searching for tracks in the history."
  },
  "stepper": {
    "design": "Design and content",
    "images": "Images",
    "last": "Your turn",
    "monetization": "Monetization",
    "name": "Name",
    "next": "Next step",
    "plan": "Offer",
    "previous": "Previous step",
    "save": "Save"
  },
  "stream-list": {
    "search-placeholder": "Search a stream",
    "empty-search-title": "No stream found",
    "empty-search-description": "Try another keyword.",
    "sort-confirm-title": "Sort alphabetically?",
    "sort-confirm-message": "The current order of your streams will be replaced by alphabetical sorting.",
    "sort-confirm-button": "Sort",
    "cancel": "Cancel"
  },
  "stream-list-item": {
    "edit": "Edit",
    "move-to-top": "Send to top",
    "move-to-bottom": "Send to bottom",
    "delete": "Delete",
    "delete-confirm-title": "Delete this stream?",
    "delete-confirm-message": "Are you sure you want to delete this stream? This action cannot be undone.",
    "delete-confirm-button": "Delete",
    "cancel": "Cancel"
  },
  "stream-edit": {
    "choose-mountpoint": "Choose a mount point",
    "choose-radio": "Choose a radio",
    "logo": "Stream logo",
    "mount-point": "Mount point",
    "name": "Stream name",
    "other": "MP3 / AAC",
    "radio": "Radio",
    "radioking-no-radios-error": "You need to own a RadioKing stream to choose this option",
    "stream-type": "Stream type",
    "stream-url": "Stream URL",
    "title-url": "Titling URL",
    "title-url-infobox": "💡 Please enter a webpage URL that displays only: 'Artist - Song Title'",
    "url-hls-not-allowed": "Only HLS streams can use a .m3u8 URL",
    "url-required": "A URL is required"
  },
  "stream-modal": {
    "title-add": "Add a stream",
    "title-edit": "Edit stream",
    "name-placeholder": "Stream name",
    "type-placeholder": "Select a type",
    "title-url-description": "Share the URL of a page that simply contains: 'Artist - Song title'",
    "cancel": "Cancel",
    "confirm-close": "Closing this window will result in losing your current changes. Are you sure you want to quit without saving?",
    "add": "Add",
    "save": "Save",
    "duplicate-url": "This stream is already used by {name}"
  },
  "toast": {
    "generic-error": "An error occurred. Please try again later",
    "generic-fetch-error": "An error occurred. Please try again later",
    "login_error": "Wrong password and/or username",
    "notification-deleted": "Your notification was deleted",
    "notification-draft": "Your daft was saved",
    "notification-frequency-error": "You must space out the sending of your notifications by at least 5 minutes.",
    "notification-quota-error": "You've exceeded your quota and sent too many push notifications.",
    "notification-scheduled": "Notification scheduled",
    "notification-sent": "Notification sent",
    "notification-updated": "Notification updated",
    "post-config-success": "Your changes have been successfully saved."
  },
  "tutorial-modal": {
    "close": "View later",
    "validate": "I'm done"
  },
  "unsaved-changes-dialog": {
    "cancel": "Cancel",
    "close-confirmation-button": "Close without saving",
    "close-confirmation-message": "Close without saving",
    "close-confirmation-message-details": "Do you want to close without saving the changes?"
  },
  "update-content": {
    "save": "Save",
    "subtitle": "Modify the design and content of your application.",
    "title": "Design and content"
  },
  "update-settings": {
    "nav": {
      "logos": "Screens and logos",
      "monetization": "Monetization",
      "name": "Name",
      "privacy": "Privacy"
    },
    "save": "Save and publish",
    "subtitle": "Modify your application settings.",
    "title": "Settings"
  },
  "update_toast": {
    "update-available": "An update is available.",
    "update-now": "Update now"
  },
  "upgrade-offer": {
    "button": "Upgrading to the higher offer",
    "description": "Keep your listeners informed in real time with ultra-precise, personalized notifications (filtered by country, language, platform, and more). Boost your visibility!",
    "image": "/assets/smartphone-notif-example-en.png",
    "title": "Maximize audience engagement with targeted notifications"
  },
  "user-menu": {
    "customer": "Customer area",
    "help": "Help center",
    "logout": "Logout",
    "news": "News",
    "news-link": "https://headwayapp.co/radioking-en-changelog"
  },
  "welcome-animation": {
    "message": "Thank you for choosing RadioKing for your mobile app!\nWe'll guide you from editing your app to publishing it on the stores.",
    "welcome": "Welcome"
  }
}
